import { HTMLProps, ReactNode } from 'react';

import Image from 'next/image';
import Link, { LinkProps } from 'next/link';

import ArrowCircleIcon from '@/assets/icons/v2-hedaer-arrow-icon.svg';
import cn from '@/helpers/utils/classNames';

import { useDropDownContext } from '../context';

export interface RawDropdownLinkProps {
  label: string;
  icon?: ReactNode;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  href: string;
}

type DropdownLinkProps = RawDropdownLinkProps &
  (
    | ({
        as?: 'Link';
      } & Omit<LinkProps, 'href' | 'ref'>)
    | ({
        as?: 'a';
      } & Omit<HTMLProps<HTMLAnchorElement>, 'href' | 'ref'>)
  );

export type DropdownLinks = Array<DropdownLinkProps>;

export default function DropdownLink(props: DropdownLinkProps) {
  const { setInActive } = useDropDownContext();
  const { label, icon, className, iconClassName, labelClassName, as, onClick, ...restProps } = props;

  const passHref = as === 'a';

  return (
    <li className="v2-whitespace-nowrap v2-font-sweet-sans-pro v2-font-normal">
      <Link
        {...restProps}
        className={cn(
          'v2-flex v2-flex-row v2-items-center v2-font-sweet-sans-pro v2-text-sm v2-font-normal v2-duration-300 hover:v2-text-primary',
          className
        )}
        onClick={event => {
          setInActive();
          onClick && onClick(event);
        }}
        passHref={passHref}
        prefetch={!passHref}
      >
        {icon ? (
          icon
        ) : (
          <Image src={ArrowCircleIcon} className={cn('v2-mr-[9px]', iconClassName)} alt={'header arrow'} />
        )}
        <span
          className={cn(
            'v2-block v2-whitespace-normal v2-font-sweet-sans-pro v2-font-normal v2-text-sm v2-text-gray-700',
            labelClassName
          )}
        >
          {label}
        </span>
      </Link>
    </li>
  );
}
